module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_arrow_right05-79c45bede6e45e533637fea1222e11aa.svg";